module.exports = __webpack_public_path__ + "img/1.16b40b1e.jpg";